import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import Stream from 'flarum/common/utils/Stream';
import BirthdayField from '../common/components/BirthdayField';
const signUpMode = () => app.forum.attribute('datlechin-birthdays.signUp') || 'off';
export default function addSignUpField() {
  extend('flarum/forum/components/SignUpModal', 'oninit', function () {
    this.birthday = Stream('');
  });
  extend('flarum/forum/components/SignUpModal', 'fields', function (items) {
    const mode = signUpMode();
    if (mode === 'off') return;
    items.add('birthday', m(BirthdayField, {
      stream: this.birthday,
      required: mode === 'required',
      disabled: this.loading
    }), 15);
  });
  extend('flarum/forum/components/SignUpModal', 'submitData', function (data) {
    if (signUpMode() !== 'off' && this.birthday()) {
      Object.assign(data, {
        birthday: this.birthday()
      });
    }
  });
}